export default __webpack_public_path__ + "media/images/icons/x-icon-9d08f7db0e0066985995a8baf86158cd.svg";